import { render, staticRenderFns } from "./changeRecord.vue?vue&type=template&id=36f1be29&scoped=true&"
import script from "./changeRecord.vue?vue&type=script&lang=js&"
export * from "./changeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f1be29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f1be29')) {
      api.createRecord('36f1be29', component.options)
    } else {
      api.reload('36f1be29', component.options)
    }
    module.hot.accept("./changeRecord.vue?vue&type=template&id=36f1be29&scoped=true&", function () {
      api.rerender('36f1be29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/changeRecord.vue"
export default component.exports